import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterOption } from '../../pages/theme/filters/filters.component';

@Component({selector:'app-sort-control',standalone:true,imports:[CommonModule,FormsModule],templateUrl:'./sort-control.component.html',styleUrls:['./sort-control.component.scss']})
export class SortControlComponent {
  private static nextId = 0;
  readonly id = 'ia-sort-control-' + ++SortControlComponent.nextId;
  @Input() options: FilterOption[] = [];
  @Input() field: string | null = null;
  @Input() direction = 'asc';
  @Output() optionSelected = new EventEmitter<FilterOption>();
  @Output() directionRequested = new EventEmitter<void>();

  get selectedOption(): FilterOption | undefined { return this.options.find(option => option.field.toLowerCase() === this.field?.toLowerCase()); }
  get selectedField(): string { return this.selectedOption?.field || this.field || ''; }
  get fallbackLabel(): string { return this.field?.replace(/([a-z0-9])([A-Z])/g, '$1 $2') || 'Choose field'; }
  get ascending(): boolean { return this.direction?.toLowerCase() === 'asc'; }
  choose(field: string): void {
    const option = this.options.find(item => item.field === field);
    if (option) this.optionSelected.emit(option);
  }
}
